import { render, staticRenderFns } from "./noticelist.vue?vue&type=template&id=5712547c&scoped=true"
import script from "./noticelist.vue?vue&type=script&lang=js"
export * from "./noticelist.vue?vue&type=script&lang=js"
import style0 from "./noticelist.vue?vue&type=style&index=0&id=5712547c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5712547c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\iotcarduserui\\iotcardpc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5712547c')) {
      api.createRecord('5712547c', component.options)
    } else {
      api.reload('5712547c', component.options)
    }
    module.hot.accept("./noticelist.vue?vue&type=template&id=5712547c&scoped=true", function () {
      api.rerender('5712547c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/noticelist.vue"
export default component.exports